var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyorderRejected1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Myorder_Rejected"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Myorder_Rejected",
    clipPath: "url(#clip-Myorder_Rejected)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Denied",
    d: "M70.363,78.48c-.276-.043-.559-.064-.831-.125a6.7,6.7,0,0,1-3.761-2.242,6.584,6.584,0,0,1-1.519-5.882,6.687,6.687,0,0,1,3.933-4.857,6.551,6.551,0,0,1,3.962-.494,6.662,6.662,0,0,1,3.371,1.641,6.775,6.775,0,0,1,2.2,3.915A8.919,8.919,0,0,1,77.8,72.24a5.41,5.41,0,0,1-.125.831A6.786,6.786,0,0,1,75.367,76.9a6.672,6.672,0,0,1-3.21,1.5A6.981,6.981,0,0,1,70.363,78.48Zm-4.632-6.838a5.211,5.211,0,0,0,.706,2.6.4.4,0,0,0,.681.1L73.658,67.8a.4.4,0,0,0-.093-.681,5.082,5.082,0,0,0-3.94-.534A5.214,5.214,0,0,0,65.731,71.642Zm10.46,0a5.252,5.252,0,0,0-.7-2.594.408.408,0,0,0-.706-.093l-6.512,6.512a.4.4,0,0,0,.1.7,5.115,5.115,0,0,0,3.525.609A5.222,5.222,0,0,0,76.191,71.642Z",
    transform: "translate(-63.951 -64.638)",
    fill: "red"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyorderRejected1);
export default __webpack_public_path__ + "static/media/Myorder_Rejected-1.68909dd1b4c6b0a69bcd3b4dd76f8528.svg";
export { ForwardRef as ReactComponent };